import React from 'react';
import { Link } from 'react-router-dom';
import LogoIcon from '../_assets/imgs/logo.svg';

const Logo = () => (
  <Link
    className="logo"
    to="/"
    style={{ display: 'inline-block', verticalAlign: 'top' }}
  >
    <img src={LogoIcon} alt="React Logo" />
  </Link>
);

export default Logo;
